import { Versions } from 'projects/access-control/src/app/Domain/Entities/versions.interface';
import {
	postVersionsModule,
	putVersionsModule,
} from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.action';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-modal-new-version',
	templateUrl: `./modal-new-version.component.html`,
	styleUrls: ['./modal-new-version.component.scss'],
})
export class ModalNewVersionComponent implements OnDestroy, OnInit {
	subscriptionTranslate!: Subscription;
	translateModal: any;
	formVersion!: FormGroup;
	constructor(
		private store: Store,
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<ModalNewVersionComponent>,
		private translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.getDataTranslate();
	}

	ngOnInit(): void {
		this.formVersion = this.formBuilder.group({
			version: [
				this.data?.version?.version,
				[Validators.required, Validators.pattern(/^\d+(\.\d+){2}$/)],
			],
			date: ['', Validators.required],
			features: this.formBuilder.array([]),
			improvements: this.formBuilder.array([]),
		});
		if (this.data.type !== 'add') {
			this.formVersion.controls['version'].disable({ onlySelf: true });
			this.formVersion.controls['date'].setValue(this.formatDateForInput(this.data?.version?.date));
			const version: Versions = this.data.version;
			version.features.forEach((item) => {
				this.features.push(this.formBuilder.control(item));
			});
			version.improvements.forEach((item) => {
				this.improvements.push(this.formBuilder.control(item));
			});
		}
	}
	onNoClick() {
		this.dialogRef.close();
	}

	get f() {
		return this.formVersion.controls;
	}
	get features() {
		return this.formVersion.get('features') as FormArray;
	}
	get improvements() {
		return this.formVersion.get('improvements') as FormArray;
	}

	addFeatures() {
		this.features.push(this.formBuilder.control(''));
	}

	removeFeatures(index: number) {
		this.features.removeAt(index);
	}

	addImprovements() {
		this.improvements.push(this.formBuilder.control(''));
	}

	removeImprovements(index: number) {
		this.improvements.removeAt(index);
	}

  formatDateForInput(dateString: string): string {
    const [year, month, day] = dateString.split('-').map(Number);

    const date = new Date(year, month - 1, day); // Restar 1 al mes porque los meses en JavaScript son de 0 a 11
    if (isNaN(date.getTime())) {
        throw new Error('Invalid date format');
    }

    const formattedDay = String(date.getDate()).padStart(2, '0');
    const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
    const formattedYear = date.getFullYear();
    return `${formattedYear}-${formattedMonth}-${formattedDay}`;
}
	cleanEmptyStrings(data: Versions): Versions {
		data.features = data.features.filter((feature) => feature.trim() !== '');
		data.improvements = data.improvements.filter((improvement) => improvement.trim() !== '');
		return data;
	}
	save() {
		const version: Versions = this.cleanEmptyStrings(this.formVersion.value);
		if (version && this.formVersion.valid) {
			if (this.data.type === 'add') {
				this.store.dispatch(
					postVersionsModule({ version, ids: { pk: this.data.module.pk, sk: this.data.module.sk } })
				);
			} else {
				this.store.dispatch(
					putVersionsModule({
						version,
						idsModule: { pk: this.data.module.pk, sk: this.data.module.sk },
						ids: { pk: this.data.version.pk, sk: this.data.version.sk },
					})
				);
			}
			this.onNoClick();
		}
	}
	getDataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.systemModules.modalVersion;
		});
	}
	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
